import {
  Box,
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";

export default function ExampleConfigForm() {
  const [depositType, setDepositType] = useState("flat");
  const [depositAmount, setDepositAmount] = useState("");
  const [applyToScheduling, setApplyToScheduling] = useState(true);
  const [applyToOnlineBooking, setApplyToOnlineBooking] = useState(false);

  return (
    <Stack>
      {/* Where deposits should be applied */}
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
          Where deposits should be applied
        </Typography>
        <Stack spacing={1}>
          <FormControlLabel
            control={
              <Checkbox
                checked={applyToScheduling}
                onChange={(e) => setApplyToScheduling(e.target.checked)}
                color="primary"
              />
            }
            label="Appointment scheduling"
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={applyToOnlineBooking}
                onChange={(e) => setApplyToOnlineBooking(e.target.checked)}
                color="primary"
              />
            }
            label="Online booking"
          />
        </Stack>
      </Box>

      {/* Deposit type */}
      <Box>
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
          Deposit type
        </Typography>
        <RadioGroup
          value={depositType}
          onChange={(e) => setDepositType(e.target.value)}
        >
          <FormControlLabel
            value="flat"
            control={<Radio color="primary" />}
            label="Flat deposit amount"
          />
          <FormControlLabel
            value="different"
            control={<Radio color="primary" />}
            label="Different deposits for services"
          />
        </RadioGroup>
      </Box>

      {/* Deposit amount */}
      {depositType === "flat" && (
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 2 }}>
            Deposit amount
          </Typography>
          <TextField
            fullWidth
            type="number"
            placeholder="0.00"
            value={depositAmount}
            onChange={(e) => setDepositAmount(e.target.value)}
            InputProps={{
              startAdornment: <Typography sx={{ mr: 1 }}>$</Typography>,
            }}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
              },
            }}
          />
        </Box>
      )}
    </Stack>
  );
}
